module.exports = __webpack_public_path__ + "static/media/pt.04fa443d.svg";